import { render, staticRenderFns } from "./manifestPrint.template.vue?vue&type=template&id=3b28ed77&scoped=true&"
var script = {}
import style0 from "./manifestPrint.template.vue?vue&type=style&index=0&id=3b28ed77&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b28ed77",
  null
  
)

export default component.exports